import { LAST_WORKSPACE } from "@/constants/local-storage-keys";
import { PAYMENT_METHODS } from "badlands-shared";
import { sortString } from "../sort-utils/sort-utils";

export const hasWorkspace = (workspaces, workspaceId) => {
  return workspaces?.some((workspace) => workspace?.id === workspaceId);
};

export const canPurchaseCredits = (workspace) => {
  return workspace?.WorkspaceConfig?.paymentMethod !== PAYMENT_METHODS.MANUAL;
};

const getStorage = () => {
  if (typeof window === "undefined") {
    return undefined;
  }
  return window.localStorage;
};

export const getDefaultWorkspaceIdFromList = (workspaces = []) => {
  if (!Array.isArray(workspaces) || !workspaces.length) {
    return undefined;
  }
  return workspaces.find((workspace) => workspace?.isDefault)?.id;
};

export const resolveWorkspaceId = ({
  routeWorkspaceId,
  lastWorkspaceId,
  workspaces = [],
  fallbackWorkspaceId,
} = {}) => {
  const candidates = [
    routeWorkspaceId,
    lastWorkspaceId,
    getDefaultWorkspaceIdFromList(workspaces),
    fallbackWorkspaceId,
    workspaces[0]?.id,
  ];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    if (!workspaces.length || hasWorkspace(workspaces, candidate)) {
      return candidate;
    }
  }

  return undefined;
};

export const getLastWorkspaceId = () => {
  const storage = getStorage();

  if (!storage) {
    return undefined;
  }

  return storage.getItem(LAST_WORKSPACE);
};

export const setLastWorkspaceId = (workspaceId) => {
  const storage = getStorage();

  if (!storage || !workspaceId) {
    return;
  }

  storage.setItem(LAST_WORKSPACE, workspaceId);
};

export const sortWorkspaces = (workspaces = []) => {
  return workspaces.sort((a, b) => sortString(a?.name, b?.name));
};
